import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import http from '@/api/http';

dayjs.locale(http.defaults.headers.common.locale);
dayjs.extend(localizedFormat);

export default dayjs;
